import { graphql } from "~/gql";

export const CREATE_CLIENT = graphql(/* GraphQL */ `
  mutation createClient($data: ClientCreateInput!) {
    createClient(data: $data) {
      id
      name
      externalId
      externalReference
      type
      excludeTax
      gpmDangerThreshold
      gpmWarningThreshold
      currency {
        id
        code
        symbol
      }
    }
  }
`);
